// ---
// Geomarketing
// ---
class Geomarketing {
  // Constructor
  constructor($el) {
    if (!$el.length) return

    this.$el = $el

    $el.on('change', '.geomarketing__country-select', this.filterByCountry.bind(this))
    this.filterByCountry()
  }

  initTable() {
    const $table = this.$el.find('.dashboard__table')

    // show/hide more logic
    let shown = false
    const $toggle = this.$el.find('.geomarketing__show-more')

    const showOrHideMore = () => {
      const limit = 6

      const $bound = $table.find(`tbody tr:nth-child(${limit})`)
      const totalCount = $table.find('tbody tr').length
      const restCount = totalCount - 6

      if (!$bound.length) return

      // Display all before, hide/show all after
      $bound.toggle(true)
      $bound.prevAll('tr').toggle(true)
      $bound.nextAll('tr').toggle(shown)

      $toggle.toggleClass('geomarketing__show-more--less', shown)

      $toggle.find('span').text(shown ? 'Show less' : `Show ${restCount} more`)
    }

    showOrHideMore()

    $toggle.on('click', () => {
      shown = !shown
      showOrHideMore()
    })
  }

  filterByCountry() {
    const $select = this.$el.find('.geomarketing__country-select')

    const countryId = $select.val()
    const fetchUrl = this.$el.data('table-fetch-url')

    const $tableContainer = this.$el.find('.geomarketing__table')

    $tableContainer.toggleClass('is-loading', true)

    $.get(fetchUrl, { country_id: countryId })
      .then(data => {
        $tableContainer.html(data)
        this.initTable()
      })
      .always(() => {
        $tableContainer.toggleClass('is-loading', false)
      })
  }
}

// ---
// Init
// ---
document.addEventListener('DOMContentLoaded', function () {
  return new Geomarketing($('.geomarketing'))
})
